import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import ExtensionIcon from '@material-ui/icons/Extension';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import SettingsIcon from '@material-ui/icons/Settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import HomeIcon from '@material-ui/icons/Home';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { makeStyles } from '@material-ui/core';
import { useAuth } from '../../auth/AuthContext';

const useStyles = makeStyles({
  sidebarWrap: {
    height: '100%',

    '& aside': {
      backgroundColor: '#004B2B !important',
      color: '#FFFFFF !important',
    },

    '& nav': {
      backgroundColor: '#004B2B !important',
      color: '#FFFFFF !important',
    },

    '& [class*="Sidebar"]': {
      backgroundColor: '#004B2B',
    },

    '& [class*="Sidebar-root"]': {
      backgroundColor: '#004B2B !important',
    },

    '& [class*="SidebarDrawer"]': {
      backgroundColor: '#004B2B !important',
    },

    '& [class*="SidebarItem"]': {
      color: 'rgba(255, 255, 255, 0.9) !important',
    },

    '& a, & button': {
      color: 'rgba(255, 255, 255, 0.9) !important',
    },

    '& svg': {
      color: 'rgba(255, 255, 255, 0.9) !important',
    },

    '& a:hover, & button:hover': {
      backgroundColor: '#007A3D !important',
      color: '#FFFFFF !important',
    },

    '& a:hover svg, & button:hover svg': {
      color: '#FFFFFF !important',
    },

    '& [aria-current="page"]': {
      backgroundColor: '#00AE58 !important',
      color: '#FFFFFF !important',
      borderLeft: '4px solid #FFFFFF',
    },

    '& [aria-current="page"] svg': {
      color: '#FFFFFF !important',
    },

    '& hr': {
      backgroundColor: 'rgba(255, 255, 255, 0.18) !important',
    },

    '& [class*="MuiDivider"]': {
      backgroundColor: 'rgba(255, 255, 255, 0.18) !important',
    },
  },
});

const AcmeSidebar = ({ navItems }: { navItems: any }) => {
  const classes = useStyles();
  const { logout } = useAuth();

  const nav = navItems.withComponent((item: any) => (
    <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
  ));

  nav.take('page:search');

  return (
    <div className={classes.sidebarWrap}>
      <Sidebar>
        <SidebarLogo />

        <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
          <SidebarSearchModal />
        </SidebarGroup>

        <SidebarDivider />

        <SidebarGroup label="Menu" icon={<MenuIcon />}>
          <SidebarItem icon={HomeIcon} to="/" text="Home" />
          <SidebarItem icon={ExtensionIcon} to="/api-docs" text="APIs" />
          <SidebarItem icon={LibraryBooks} to="/docs" text="Docs" />
        </SidebarGroup>

        <SidebarSpace />

        <SidebarDivider />

        <SidebarItem icon={ExitToAppIcon} text="Logout" onClick={logout} />

        <SidebarDivider />

        <SidebarItem icon={SettingsIcon} to="/settings" text="Settings" />
      </Sidebar>
    </div>
  );
};

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => <AcmeSidebar navItems={navItems} />,
  },
});